module.exports = __webpack_public_path__ + "img/linkedinOpacity.5e5ba6e9.svg";